<template lang="pug">
div(class="adverts")
  v-row(class="mb-8")
    v-col
      NewBuildingsSlider
  v-row
    v-col(cols="6",
      v-for="item in counters",
      :key="item.key")
      v-img(:src="require(`@/assets/images/${item.key}.jpg`)")
      h3(class="adverts-title mb-2") {{ item.title }}
      span(
        class="adverts-subtitle d-block mb-2",
        v-for="el in item.counters",
        :key="el.title") {{ el.title }}
        span(class="ml-4 adverts-subtitle--grey") {{ el.count }}
          span(
            class="adverts-subtitle d-block mt-2 pl-3",
            v-if="el.childCounters",
            v-for="child in el.childCounters",
            :key="child.title") {{ child.title }}
            span(class="ml-4 adverts-subtitle--grey") {{ child.count }}
</template>
<script>
export default {
  components: {
    NewBuildingsSlider: () => import('./NewBuildingsSlider')
  },
  data: () => ({
    counters: []
  }),
  mounted() {
    this.$store
      .dispatch('GET_COUNTERS')
      .then(response => (this.counters = response.blocks))
  }
}
</script>

<style scoped lang="scss">
.adverts {
  .v-image {
    border-radius: 6px;
    margin-bottom: 20px;
  }
  &-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: -0.522222px;
    color: #292929;
  }
  &-subtitle {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.391667px;
    color: #456990;
    &--grey {
      color: #bbb;
    }
  }
}
</style>
